import styled from "styled-components";
export const StyledTable = styled.table `
  table-layout: ${({ tableLayout }) => tableLayout};
  border-collapse: collapse;

  thead,
  tbody {
    tr {
       min-height: 2.5rem;
      height: 2.5rem; 
      box-sizing: border-box;

      td {
        label {
          padding-right: 0;
        }
        :first-child {
          ${({ tableType }) => tableType !== "TB02"
    ? "padding-left: 1rem"
    : "padding-left: 0rem;padding-right: 0rem"};
        }
        :last-child {
          padding-right: 1rem;
        }
      }
    }
  }

  thead td {
    box-sizing: border-box;
    vertical-align: top;
    :first-child {
      ${({ tableType }) => tableType === "TB02" ? "vertical-align: top;padding: 0;" : ""};
      > div {

        }
      }
    }
  }

  tbody {
    tr {
      td {
        ${({ tableType }) => tableType === "TB03" || tableType === "TB04"
    ? "padding: 0.5rem 1rem"
    : ""};
      }
        ${({ tableType }) => tableType === "TB03"
    ? "vertical-align: top"
    : tableType === "TB04"
        ? "vertical-align: middle"
        : "vertical-align: baseline"};
      }
      td:first-child {
        ${({ tableType }) => tableType === "TB02" ? "padding: 0rem;vertical-align: top" : ""};
      }
    }
  }

  tfoot {
    tr {
      height: 2rem;
    }
  }
`;
